import React, { Component, Fragment } from 'react';
import isWindow from 'components/common/helpers/isWindow';
import SecureLoadingContent from '../common/SecureLoadingContent';
import { connect } from 'react-redux';
import {
  setDashboardReservations
} from 'components/actions/serviceActions';
import Slider from './components/Slider';

class Dashboard extends Component {

  callbackDataLoaded = (data) => {
    this.props.setDashboardReservations(data);
  }

  render() {
    if (!isWindow) return null;
    return (
      <SecureLoadingContent
        path="/pwa/dashboard/reservations"
        method="get"
        callback={this.callbackDataLoaded}
      >
        <Slider />
      </SecureLoadingContent>
    );
  }
}

export default connect(
  null,
  { setDashboardReservations }
)(Dashboard);
